module.exports = __webpack_public_path__ + "img/bg-image-10.c622ced6.jpg";